<template>
<!-- 申请列表 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
      <!--  -->
      <div class="search">
         <!--  -->
        <div class="search-gropu">
          课程期次：
          <el-select v-model="course" clearable placeholder="请选择课程期次">
            <el-option
              v-for="item in course_list"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!--  -->
        <div class="search-gropu">
          关键字：
          <el-input class="search-child"  @keyup.enter.native="pullData" v-model="keywords" placeholder="请输入关键字"></el-input>
        </div>
        <!--  -->
        <div class="search-gropu on">
          用户类型：
          <el-select v-model="type"  clearable  placeholder="请选择类型">
            <el-option v-for="(item,index) in userTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
            <el-option  label="已注销" :value="-1"></el-option>
          </el-select>
          <el-button style="margin-left:10px;" type="primary" @click="pullData" size="medium">查询</el-button>
          
        </div>
      </div>
      <div class="search">
        <div class="search-gropu" style="text-align:right;">
          <el-button style="margin-left:10px;" type="primary" @click="exportExcelHandle" size="medium">导出</el-button>
          <el-button style="margin-left:10px;" type="primary" @click="addUser()" size="medium">创建</el-button>
          <el-button style="margin-left:10px;" type="primary" @click="impResult()" size="medium">批量添加</el-button>
          <input v-if="isShowFile"  type="file" ref="inputResult" style="display:none" @change="importExcel" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="course" width="150" label="课程期次"></el-table-column>
          <el-table-column prop="id" label="用户ID" width="65"></el-table-column>
          <el-table-column prop="name" label="用户姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="email" label="邮箱账号"></el-table-column>
          <el-table-column width="100" label="账号类型">
            <template slot-scope="scope">
              <el-tag v-for="(item,index) in userTypeList" :key="index" size="small" v-if="scope.row.type==item.id">{{item.name}}</el-tag>
              <el-tag type="danger" size="small" v-if="scope.row.type==-1">已注销</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间"></el-table-column>
          <el-table-column prop="admin_id" width="100px" label="后台用户id"></el-table-column>
          <el-table-column width="80" label="已购产品">
            <template  slot-scope="scope">
              <a style="color:#0a76f5;text-decoration: underline;cursor: pointer;" @click="checkBuyList(scope.$index, scope.row)">查看</a>
            </template>
          </el-table-column>
          <el-table-column width="200px"   label="操作">
              <template  slot-scope="scope">
                <div class="bj" style="margin-bottom:10px;">
                  <el-button type="primary" size="mini"  @click="purchaseRecords(scope.$index, scope.row)" >购买记录</el-button>
                  <el-button type="primary" size="mini"  @click="updateHandle(scope.$index, scope.row)" >编辑</el-button>
                </div>
                <div class="bj">
                  <el-button type="success" size="mini"  @click="relationHandle(scope.$index, scope.row)" >关联测评</el-button>
                  <el-button v-if="scope.row.type!=-1" type="danger" size="mini"  @click="userOff(scope.$index, scope.row)" >注销</el-button>
                </div>
              </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <el-pagination class="pages" 
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pages.size" 
        :current-page="pages.page"
        background 
        layout="sizes,prev, pager, next" 
        :total="pages.count"> 
      </el-pagination>
    </div>
    <!-- 添加单个用户 -->
    <el-dialog title="用户管理" :visible.sync="addUserDialog">
      <el-form :model="form">
        <el-form-item label="课程期次" :label-width="formLabelWidth">
          <el-input v-model="form.course" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="账户类型" :label-width="formLabelWidth">
          <el-select v-model="form.type" placeholder="请选择账户类型">
            <el-option  label="已注销" :value="-1"></el-option>
            <el-option v-for="(item,index) in userTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 购买测评 -->
        <el-form-item  label="购买测评" :label-width="formLabelWidth">
          <div class="btn-purchase">
            <el-button type="primary" @click="purchaseHandle()" size="small">添加测评</el-button>
          </div>
          <el-table v-if="!purchaseBool" :data="purchaseList" border style="width: 100%">
            <el-table-column prop="name" label="测评名称" ></el-table-column>
            <el-table-column prop="count" label="数量" ></el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="form.id?saveUpdate():saveUser()">保 存</el-button>
        <el-button type="primary" @click="saveOrEmail()">发 送</el-button>
      </div>
    </el-dialog>
    <!-- 测评商品 -->
    <el-drawer  :visible.sync="purchaseBool" direction="rtl">
      <!-- 商品 -->
      <el-card v-for="(item,index) in purArr" :key="index" class="box-card">
        <div class="pur-card">
          <el-checkbox class="checkBox" @change="purChange(index,item.id,item.name,'id')"  >
            <div class="checkBox-title text-ellipsis">{{item.name}}</div>
            <el-input @change="purChange(index,purObj.count[index],item.name,'count')" style="width:60px;margin-left:auto;" v-model="purObj.count[index]" placeholder="数量"></el-input>
          </el-checkbox>
        </div>
      </el-card>
      <!-- 底部保存按钮 -->
      <div class="demo-drawer__footer">
        <el-button @click="purchaseBool=false">取 消</el-button>
        <el-button type="primary" @click="savePurCount()" >提 交</el-button>
      </div>
    </el-drawer>
    <!-- 购买记录 -->
    <el-drawer  :visible.sync="chargeBool" direction="rtl">
      <!-- 卡片 -->
      <el-card v-for="(item,index) in recordsList" :key="index" class="box-card">
        <div slot="header" >
          <span class="on">{{item.time}}</span>
        </div> 
        <div v-for="(ite,idx) in item.arr" :key="idx" class="text item">
          <span class="on">{{ite.name}}</span>，购买了<span class="on">{{ite.count}}</span>个。{{ite.type==1?'后台充值':(ite.type==2?'链接充值':'')}}
        </div>
      </el-card>
    </el-drawer>
    <!-- 导入 -->
    <el-dialog
      :visible.sync="importBool"
      :close-on-click-modal="false"
      width="70%"
       style="text-align:center;">
      <div class="main">
        <!-- list -->
        <div class="list-box">
          <el-table :data="import_list" show-overflow-tooltip border style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column prop="course" width="150" label="课程期次"></el-table-column>
            <el-table-column prop="name" label="用户姓名"></el-table-column>
            <el-table-column width="140" prop="phone" label="手机号"></el-table-column>
            <el-table-column width="140" prop="email" label="邮箱账号"></el-table-column>
            <el-table-column width="120" label="账号类型">
              <template slot-scope="scope">
                <el-tag v-for="(item,index) in userTypeList" :key="index" size="small" v-if="scope.row.type==item.id">{{item.name}}</el-tag>
                <el-tag type="danger" size="small" v-if="scope.row.type==-1">已注销</el-tag>
              </template>
            </el-table-column>
            <!--  -->
            <el-table-column width="80" label="已购产品">
              <template  slot-scope="scope">
                <a style="color:#0a76f5;text-decoration: underline;cursor: pointer;" @click="importPurchaseRecords(scope.$index, scope.row)">查看</a>
              </template>
            </el-table-column>
             <!--  -->
            <el-table-column  width="180" label="原有账号">
              <template  slot-scope="scope">
                <span>{{isImpOld(scope.row.phone,scope.row.name)?'是':'否'}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span  slot="footer" class="dialog-footer">
        <el-button @click="importMsg()">取 消</el-button>
        <el-button type="primary" @click="impConfirm(1)">导入原有账号</el-button>
        <el-button type="primary" @click="impConfirm(2)">创建账号并发送邮件</el-button>
      </span>
    </el-dialog>
    <!-- 导入的购买记录 -->
    <!-- 购买记录 -->
    <el-drawer  :visible.sync="chargeBool2" direction="rtl">
      <!-- 卡片 -->
      <el-card  class="box-card">
        <div slot="header" >
          <span class="on">{{new Date().toLocaleDateString().replace(/\//g,'-')}}</span>
        </div> 
        <div  v-for="(item,index) in recordsList2" :key="index" class="text item">
          <span class="on">{{item.name}}</span>，待充值测评<span class="on">{{item.count}}</span>个。
        </div>
      </el-card>
    </el-drawer>
    <!-- 关联测评 -->
    <el-dialog title="关联测评" :visible.sync="relationBool" width="30%">
      <el-form :model="form">
        <el-form-item label="请选择要关联的测评" :label-width="'180px'">
          <el-select v-model="relationObj.cid" placeholder="请选择测评">
            <el-option v-for="(item,index) in relationArr" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="relationBool = false">取 消</el-button>
        <el-button type="primary" @click="saveRelation()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  userList,getUserTypes,userAll,
  addUser,updateUser,disableUser,addUserList,checkUserList,
  chargeList,buyList,
  getProducts,charge,
  getCepingList,
  sendUserMail,
  addRelation,
  getCourseList
} from "@/api/consultant";
import { exportExcel,deepCopy,importf } from "@u/tools";
import Bus from '@u/bus'
export default {
    data() {
        return{
            list: [],
            userTypeList:[],
            pages: {},
            keywords:'',
            type:null,
            obj:{},
            // 添加单条用户
            addUserDialog:false,
            form:{},
            formLabelWidth: '120px',
            // 购买记录
            recordsList:[],
            chargeBool:false,
            // 购买测评产品数组
            purchaseList:[],
            purObj:{
              count:[],
              id:[],
              name:[]
            },
            id:null,
            purArr:[],
            purchaseBool:false,
            // 导入原有账号还是新创建
            import_list:[],
            import_old_list:[],
            import_arr_list:[],
            importBool:false,
            chargeBool2:false,
            recordsList2:[],
            // 判断是否有名称不对的ceping
            // cpBool:false,
            //
            btnIsCanve:true,
            // 课程期次
            course:'',
            course_list:[],
            // 关联测评
            relationBool:false,

            relationObj:{
              uid:null,
              cid:null
            },
            relationArr:[],
            isShowFile:true,
            old_account_list: [],
            // 存放查询的测评商品
            productList:[]
        }
    },
    methods:{
      // 判断是否存在原有账号
      isImpOld(phone,name){
        return this.old_account_list.includes(name + ',' + phone);
      },
      // 点击批量导入触发
      impResult(){
        this.isShowFile = true;
        this.$nextTick(()=>{
          this.$refs.inputResult.click();
        });
        
      },
      // 提交关联测评
      saveRelation(){
        if(!this.relationObj.cid){
          this.$message('关联测评不能为空！');
          return
        }
        this.$showLoading();
        addRelation(this.relationObj).then(res=>{
          if(res.error>0){
            this.$message(res.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '关联成功',
            type: 'success'
          });
          
          this.relationObj = {
            uid:null,
            cid:null
          };
          this.relationBool = false;
          this.$hideLoading();
        });
      },
      /*
       *@param: 
       *@return: 
       *@Description: 关联测评
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2020-06-30 10:20:12
      */
      relationHandle(index,row){
        this.$showLoading();
        getCepingList().then(res=>{
          this.relationArr = res.list;
          this.relationObj.uid = row.id;
          this.$hideLoading();
          this.relationBool = true;
        });
      },
      // 导入数据
      imporData(v){
        let self = this;
        let arr = self.import_list;
        // 购买测评商品
        self.$showLoading();

        getProducts().then((data)=>{
          if(data.error>0){
            self.$message(data.msg);
            return
          }
          let list = data.list;
          // 存放测评商品，用于查看购买记录使用
          this.productList = data.list;
          for(let p=0;p<arr.length;p++){
            
            // 如果没有添加测评
            if(!arr[p].chargeList || arr[p].chargeList.length==0){
              
            }else{
              let productMap = {};
              let productIds = [];

              for(let h=0;h<list.length;h++){
                productMap[list[h].name] = list[h].id;
                productIds.push(list[h].id);
              }

              let isValid = true;
              for(let k=0;k<arr[p].chargeList.length;k++){
                  let product_id = undefined;
                  if(self.btnIsCanve) {
                    product_id = productMap[arr[p].chargeList[k].product_id];
                  } else {
                    product_id = arr[p].chargeList[k].product_id;
                  }
                 
                  if(typeof product_id != 'undefined' && productIds.indexOf(product_id) >= 0){
                    arr[p].chargeList[k].product_id = product_id;
                  }else{
                    self.$delete(arr[p].chargeList,k);
                    isValid = false;
                  }
              }

              if(!isValid){
                self.$message('请注意测评名称是否正确！');
                self.$hideLoading();
                return
              }
              // 合并同类型的测评数量
              arr[p].chargeList = self.mergeCeping(arr[p]);
            }
          }
          checkUserList({
            list:JSON.stringify(arr)
          }).then((data2)=>{
            self.$hideLoading();
            if(data2.error>0){
              self.$message(data2.msg);
              return
            }
            // 已有账号
            self.import_old_list = data2;
            self.old_account_list = [];
            for(let i = 0; i < self.import_old_list.old_data.length; i++) {
              let item = self.import_old_list.old_data[i];
              self.old_account_list.push(item.name + ',' + item.phone);
            }
            // 处理好的数据
            self.import_arr_list = arr;
            self.importBool=true;
          });


        }).catch((err)=>{
          self.$hideLoading();
        });
      },
      // 导入提示
      impConfirm(v){
        let arr = this.import_arr_list;
        let data2 = this.import_old_list;
        let str = (v==1?`你确定批量导入到原有账号${data2.old_data.length}条数据，需要创建账号并发送邮件${data2.new_data.length}条数据`:`你确定批量创建账号并发送邮件${data2.new_data.length}条数据，需要导入原有账号${data2.old_data.length}条数据`);
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(data2.fail_data.length>0){

            let userinfo_list = [];
            for(let z=0;z<data2.fail_data.length;z++){
              userinfo_list.push(data2.fail_data[z].phone);
            }

            let change_list= data2.change_data.reduce((groups, item)=>{
              let groupFound= groups.find(arrItem => item.msg === arrItem.msg);
              if(groupFound) {
                if(groupFound.name.indexOf(item.name)  == -1) {  //去重
                  groupFound.name.push(item.name);
                }
              } else {
                //不要直接在原来的对象修改，新建对象
                let newGroup = {
                    msg: item.msg,
                    name: [item.name]
                }
                groups.push(newGroup);
              }
              return groups;
            },[]);
            let msg = '';
            for(let u=0;u<change_list.length;u++){
              msg+=((u>0?'，':'')+change_list[u].name+'账户类型'+change_list[u].msg)
            }
              
            // 判断是否有手机号相同姓名不相同的用户
            if(userinfo_list.length>0 || change_list.length>0){
              this.$confirm(`${userinfo_list.join('、')}${data2.fail_data[0].msg}${change_list.length>0?'，且':''}${msg}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.allImportUserInfo(arr);
                this.importBool = false;

                let str = `你已完成批量导入到原有账号${data2.old_data.length}条数据,更改账户类型${data2.change_data.length}条,创建账号并发送邮件${data2.new_data.length}条数据。`;
                let str2 = `你已完成批量创建账号并发送邮件${data2.new_data.length}条数据,导入原有账户${data2.old_data.length}条数据，更改账户类型${data2.change_data.length}条。`;

                this.$alert((v==1?str:str2), '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }).catch(err=>{
                // this.cpBool = true;
                this.importBool = false;
              });;
            }else{
              this.allImportUserInfo(arr);
            }
          }else{
            this.allImportUserInfo(arr);
            this.importBool = false;
          }
          
        }).catch(err=>{
          // this.cpBool = true;
          this.btnIsCanve = false;
          this.importBool = false;
        });
      },
      // 批量添加接口
      allImportUserInfo(arr){
        this.$showLoading();
        addUserList({
          list:JSON.stringify(arr)
        }).then((data)=>{
          this.$hideLoading();
          if(data.error>0){
            this.$message(data.msg);
            return
          }
          this.$message('成功'+data.success+'条，'+'失败'+data.fail+'条！');
          this.pullData();
        }).catch((err)=>{
          this.$hideLoading();
        });
      },
      // 导入提示
      importMsg(){
        this.$confirm('是否确认取消本次导入？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.importBool = false;
        });
      },
      // 创建用户
      addUser(){
        this.form = {};
        this.addUserDialog = true;
      },
      emaile(id){
        sendUserMail({
          id:id
        }).then((data)=>{
          if(data.error>0){
            this.$message(data.msg);
            return
          }
          this.addUserDialog = false;
          this.$notify({
            title: '成功',
            message: '发送邮件成功',
            type: 'success'
          });
        });
      },
      // 发送邮箱
      saveOrEmail(){
        if(this.form.id){
          this.saveUpdate('sendOut');
        }else{
          this.saveUser('sendOut');
        }
        
        this.addUserDialog  = false;
      },
      // 充值接口
      chargeHandle(id){
        if(this.purchaseList.length>0){
          let arr = [];
          for(let y =0;y<this.purchaseList.length;y++){
            if(this.purchaseList[y]){
              arr.push({
                product_id:this.purchaseList[y].id,
                count:this.purchaseList[y].count
              });
            }
          }
          charge({
            id:id,
            list:JSON.stringify(arr)
          }).then();
        }
      },
      // 保存选择的测评商品和充值数量
      savePurCount(){
        this.$forceUpdate();
        this.purchaseList = [];
        let arr = this.purObj.id;
        for(let i=0;i<arr.length;i++){
          if(this.purObj.id[i] && this.purObj.count[i]){
            this.$set(this.purchaseList,i,{
              id:arr[i],
              name:this.purObj.name[i],
              count:this.purObj.count[i]
            });
          }
        }
        this.purchaseBool = false;
      },
      // 选择商品触发
      purChange(index,val,name,t){
        if(t=='id'){
          if(this.purObj.id[index] == val){
            this.$delete(this.purObj.id,index);
          }else{
            this.purObj.id[index] = val;
          }
          
          this.purObj.name[index] = name;
        }else{
          this.purObj.count[index] = val;
          this.purObj.name[index] = name;
        }
      },
      // 购买测评商品
      purchaseHandle(){
        this.$showLoading();
        getProducts().then((data)=>{
          this.purArr = data.list;
          this.$hideLoading();
        }).catch((err)=>{
          this.$hideLoading();
        });
        this.purchaseBool=true;
      },
      // 查看已购记录
      checkBuyList(index, row){
        this.$router.push({
          path:'/main/consultant_purchased',
          query:{
            id:row.id
          }
        });
      },
      // 购买记录
      purchaseRecords(index,row){
        this.$showLoading();
        chargeList({
          id:row.id
        }).then((data)=>{
          this.$hideLoading();
          if(data.error>0){
            this.$message(data.msg);
            return
          }
          let arr = Object.keys(data.result);
          this.recordsList = [];
          for(let l=0;l<arr.length;l++){
            this.recordsList.push({
              time:arr[l],
              arr:data.result[arr[l]]
            });
          }
          if(data.result instanceof Array && data.result.length==0){
            this.$message('暂无购买记录！');
            return
          }else{
            this.chargeBool = true;
          }
          
        }).catch((err)=>{
          this.$hideLoading();
        });
      },
      // 合并同类测评数量
      mergeCeping(row){
        let chargeList = [];
          
        row.chargeList.forEach((item,index)=>{
          let in_array = false;
          for(let m =0;m<chargeList.length;m++){
            if(chargeList[m].product_id == item.product_id){
              in_array = true;
              
              chargeList[m].count += item.count;
              break;
            }
          }
          if(!in_array) {
            chargeList.push({product_id: item.product_id, count: item.count});
          }
        });
        return chargeList;
      },
      // 导入充值记录
      importPurchaseRecords(index,row){
        if(row.chargeList.length==0){
          this.$message('暂无购买记录！');
            return
        }else{
          let array = this.mergeCeping(row);
          
          this.productList.map(p=>{
            return array.map(v=>{
              if(v.product_id==p.id){
                 v['name'] = p.name;
                 return v
              }else{
                return v
              }
            });
          });
          // 
          this.recordsList2 = array;
          this.chargeBool2 = true;
        }
      },
      // 导入表格
      importExcel(){
        this.isShowFile = false;
        let that = this;
        let inputDOM = that.$refs.inputResult;
        let file = inputDOM.files;
        let h = [
            '课程期次',
            '用户姓名',
            '手机号',
            '邮箱',
            '用户类型',
            // '购买测评',
            // '购买数量'
        ];
        let b =  [
          'course',
          'name',
          'phone',
          'email',
          'type',
          // 'product_id',
          // 'count'
        ];
        // 传入表格数据，取得返回的数组
        importf(file[0],h,b,this.userTypeList,'type','consultants_admin');
      },
      // 确认注销此用户
      userOff(index,row){
        this.$confirm('是否确认注销此用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$showLoading();
          disableUser({
            id:row.id
          }).then((data)=>{
            this.$hideLoading();
            if(data.error>0){
              this.$message(data.msg);
              return
            }
            this.$message({
              type: 'success',
              message: '注销成功!'
            });
            this.pullData();
          }).catch((err)=>{
            this.$hideLoading();
          });
        });
      },
      // 提交用户
      saveUser(val){

        if(!this.form.name || !this.form.phone || !this.form.email || !this.form.type){
          this.$message('姓名、手机号、邮箱、账户类型不能为空！');
          return
        }
        this.$showLoading();
        addUser(this.form).then((data)=>{
          if(data.error>0){
            this.$message(data.detail || data.msg);
            this.$hideLoading();
            return
          }
          this.addUserDialog = false;
          if(val==='sendOut'){
            this.emaile(data.user_id);
          }
          
          // 充值方法
          this.chargeHandle(data.user_id);
          this.form = {};
          this.$hideLoading();
          this.$notify({
            title: '成功',
            message: '创建账户成功',
            type: 'success'
          });
          this.pullData();
        }).catch((err)=>{
          this.$hideLoading();
        });
      },
      //导出的方法
        exportExcelHandle() {
          let h = [
              '用户ID',
              '用户姓名',
              '手机号',
              '邮箱',
              '用户类型',
              '后台用户ID',
              '创建时间'
          ];
          let b =  [
            'id',
            'name',
            'phone',
            'email',
            'type',
            'admin_id',
            'ctime'
          ];
          
          userAll(this.obj).then((res)=>{
              let list = res.list;  //把data里的tableData存到list
              for(let i=0;i<list.length;i++){
                for(let k=0;k<this.userTypeList.length;k++){
                  if(list[i].type==this.userTypeList[k].id){
                    list[i].type = this.userTypeList[k].name; 
                  }else if(list[i].type == -1){
                    list[i].type = '已注销';
                  }
                }
              }
             
              exportExcel(h,b,list,'咨询师用户管理')
          })
            
        },
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        // 获取修改单行数据
        updateHandle(index,row){
          this.form = deepCopy(row);
          // this.payCeping(row.id);
          this.addUserDialog = true;
        },
        // 查询已购买的测评
        payCeping(id){
          buyList({
            id:id
          }).then((data)=>{
            this.purchaseList = [];
            for(let i =0;i<data.list.length;i++){
              this.purchaseList.push({
                name:data.list[i].name,
                count:data.list[i].sum
              });
            }
            
          });
        },
        // 修改状态 bool: true通过，false拒绝
        saveUpdate(val){
            this.$showLoading();
            updateUser(this.form).then((data)=>{
              this.$hideLoading();
              if(data.error>0){
                  this.$message(data.msg);
                  return;
              }
              if(val==='sendOut'){
                this.emaile(this.form.id);
              }
              // 充值方法
              this.chargeHandle(this.form.id);
              this.addUserDialog = false;
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success'
              });
            
              this.pullData();
            }).catch(err=>{
                this.$hideLoading();
            });
        },
        // 初始化获取数据
        pullData(bool){
            this.$showLoading();
            // 获取账户类型
            getUserTypes().then((data)=>{
              if(data.error>0){
                this.$message(data.msg);
                return
              }
              this.userTypeList = data.list;
            });
            // 获取课程期次
            getCourseList().then((data)=>{
              this.course_list = data.list;
            });
            
            this.obj = {
              page:this.pages.page?this.pages.page:1,  //页码，默认1
              size:this.pages.size?this.pages.size:25   //每页数量，默认25
            };
            if(this.keywords){
                this.obj['keywords'] = this.keywords;
            }

            if(this.type || this.type==0){
                this.obj['type'] = this.type;
            }
            if(this.course){
                this.obj['course'] = this.course;
            }

            this.$showLoading();
            userList(this.obj).then((data)=>{
                if(data.error>0){
                  this.$message(data.msg);
                  return
                }
                this.list = data.list;

                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
            

        }
    },
    created(){
        this.pullData();
        Bus.$off('importExcel'); //先解绑，不然会多次出发
        Bus.$on('importExcel',(arr)=>{
          // 批量导入添加
          this.import_list = arr;
          this.imporData();
        });
    }
    
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.on{
  position: absolute;
  left: 30px;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 20px;
}
.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}
.search-gropu.on{
    flex:1.2;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.box-card{
  margin: 0 15px 15px;
  color:#666;
  span.on{
    font-size:14px;
    color:#333;
    font-weight:bold;
  }
}
.checkBox{
  display:flex;
  align-items: center;
}
.checkBox-title{
  margin-right: 24px;
}
.demo-drawer__footer{
  display:flex;
  justify-content: space-around;
}
</style>
<style lang="scss">
.el-checkbox__label{
  display:flex;
  align-items: center;
}
.el-drawer__body{
  overflow: auto;
}
</style>